<template>
  <v-app>
    <AppBar />
    <v-main>
      <RouterView />
    </v-main>
  </v-app>
</template>

<script setup>
import { onMounted, onBeforeUnmount } from "vue";
import { RouterView } from "vue-router";

import AppBar from "@/components/AppBar.vue";
import { useUploadStore } from "@/stores/uploadStore";

const uploadStore = useUploadStore();

// アップロード進行中にリロード / タブクローズしようとしたらブラウザ警告を出す
// (ハードリロードは JS ランタイム破棄 → upload abort なので誤操作防止)
function handleBeforeUnload(e) {
  if (uploadStore.hasActiveUploads) {
    e.preventDefault();
    e.returnValue = "アップロードが進行中です。本当に閉じますか？";
    return e.returnValue;
  }
}

onMounted(() => {
  window.addEventListener("beforeunload", handleBeforeUnload);
});

onBeforeUnmount(() => {
  window.removeEventListener("beforeunload", handleBeforeUnload);
});
</script>
